import { ss } from '../k2assets-auth';

export const signIn = (params: any) => {
    ss.signIn();
};
